import BaseApi from '../base'

const path = '/admin/domain'

export default class DomainApi extends BaseApi {
  constructor() {
    super(path)
  }
  static GetInstance = () => new DomainApi()
}
